import { t, Trans } from '@lingui/macro';
import { TireOfferV2 } from 'noddi-types';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { DateFormats, getCarDisplayName, getWheelSetTypeEmoji, noddiFormatDate } from 'noddi-util';
import { NoddiCarSvg } from '../../components/Home/CarSvg';
import { TireOfferPaymentSummary } from '../../components/TireOffer/TireOfferPaymentSummary';
interface TireOrderDetailsProps {
  tireOffer: TireOfferV2;
}

export const TireOrderDetails = ({ tireOffer }: TireOrderDetailsProps) => {
  const carName = getCarDisplayName(tireOffer.car);

  const selectedQuoteItem = tireOffer.quoteItems.find((item) => item.isSelected);

  if (!selectedQuoteItem) {
    return null;
  }

  const estimatedDeliveryDate = selectedQuoteItem.quoteItemTires[0]?.inventoryOrder?.estimatedDeliveryDate;
  const emoji = getWheelSetTypeEmoji(tireOffer.season);
  const season = tireOffer.season.value === 0 ? t`Summer tires` : t`Winter tires`;

  return (
    <div className='flex flex-col gap-6'>
      <div className='flex flex-col gap-4 md:grid md:grid-cols-2'>
        <div>
          <p className='font-bold'>
            <Trans>Estimated delivery</Trans>
          </p>
          {estimatedDeliveryDate ? (
            <>
              <div className='flex flex-row items-center gap-2'>
                <NoddiIcon name='Calendar' />
                <p>{noddiFormatDate(estimatedDeliveryDate, DateFormats.FULL_DAY_MONTH)}</p>
              </div>
            </>
          ) : (
            <p>
              <Trans>We will notify you when the tires are ordered</Trans>
            </p>
          )}
        </div>
        <div>
          <p className='font-bold'>
            <Trans>General details</Trans>
          </p>
          <div className='flex flex-col gap-1'>
            <div className='flex flex-row items-center gap-2'>
              <p className='w-7'>{emoji}</p>
              <p>{season}</p>
            </div>
            <div className='flex flex-row items-center gap-2'>
              <NoddiCarSvg scale={0.4} />
              <p>{carName}</p>
            </div>
          </div>
        </div>
      </div>

      <NoddiBasicCard className='border border-grey/30'>
        <TireOfferPaymentSummary
          quoteItemTires={selectedQuoteItem.quoteItemTires}
          genericItems={tireOffer.genericItems}
        />
      </NoddiBasicCard>
    </div>
  );
};
